import { render, staticRenderFns } from "./SideNavSection.vue?vue&type=template&id=65bef57d&scoped=true&"
import script from "./SideNavSection.vue?vue&type=script&lang=js&"
export * from "./SideNavSection.vue?vue&type=script&lang=js&"
import style0 from "./SideNavSection.vue?vue&type=style&index=0&id=65bef57d&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65bef57d",
  null
  
)

export default component.exports